<template>
  <div id="login">
    <section class="bannerprincipal pb-2">
      
      <div class="col-12">
          <b-navbar toggleable="lg" class="d-flex align-items-start" type="light">
            <b-navbar-brand to="/">
              <img
                class="img-fluid"
                src="../assets/imgs/copaprosa2025/logo-home.png"
                alt="Copa Prosa"
              />
            </b-navbar-brand>

           

            
          </b-navbar>
        </div>

      
    </section>

    <div
      class="separador text-center pt-5 "
      data-aos="fade-up"
      data-aos-delay="0"
    >
      <p class=" fXG amarillo pb-5 mt-5">Administrador
      </p>
    </div>

    <section data-aos="fade-up" data-aos-delay="200">
      <div class="container">
        <div class="row pb-5">
          <div class="col-12 col-lg-6 offset-lg-3">
            <div class="row">
              <div class="col-12">
                <form v-if="showLoginForm" @submit="login($event)">
                  <div class="col-12 text-center pb-4">
                    <h2>
                      <span class="bold amarillo">Inicia sesión</span>
                    </h2>
                  </div>
                  <div class="d-flex flex-column pb-4">
                    <div class="w-100 px-2">
                      <input
                        v-model.trim="loginForm.email"
                        type="email"
                        placeholder="Email"
                        id="email1"
                        required
                      />
                    </div>
                    <div class="w-100 px-2">
                      <input
                        v-model.trim="loginForm.password"
                        type="password"
                        placeholder="Contraseña"
                        id="password1"
                        required
                      />
                    </div>
                    <div
                      class="w-100 px-2 text-center d-flex align-items-center"
                    >
                      <button
                        type="submit"
                        class="amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
                      >
                        Continuar
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section data-aos="fade-up" data-aos-delay="200">
      <div class="container py-5">
        <div class="row text-center">
          <div class="col-12">
            <router-link
              to="/"
              class="amarillo pointer btnaction fG ml-auto mr-auto w-100"
            >
              Ir al home
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";
import SiteNav from "@/components/SiteNav2";

import { mapState } from "vuex";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";
import router from "../router/index";

export default {
  components: {
    Footer,
    
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
    };
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      console.log('enviando login');

     
            this.$store.dispatch("showLoader", true);

            e.preventDefault();

            const https = require("https");
            var qData = {
                email: this.loginForm.email,
                password: this.loginForm.password,
            };
            this.$http
                .post(
                    process.env.VUE_APP_API_URL + "login2.php",
                    JSON.stringify(qData), {
                        emulateJSON: true,
                        httpsAgent: new https.Agent({ rejectUnauthorized: false }),
                        headers: {
                            "Content-Type": "text/plain",
                            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
                        },
                    }
                )
                .then(
                    (response) => {
                        // get body data
                        this.$store.dispatch("showLoader", false);
                        console.log("res login");
                        console.log(response);

                        let res = response.body;

                        if (res.status == "ok") {
                            localStorage.setItem(
                                "user_copaprosa2021",
                                JSON.stringify(res.usuario)
                            );

                            router.push('/administrador/dashboard')
                        } else {
                            swal.fire("Oops", res.msg, "warning");
                        }
                    },
                    (error) => {
                        // error callback
                        this.$store.dispatch("showLoader", false);
                        console.log("error callback");
                        console.log(error);
                    }
                );

    },
    signup(e) {
      e.preventDefault();

      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      this.showMonedero = true;
    },
    async registro(monedero = "") {
      this.signupForm.monedero = monedero;
      console.log({ registro: this.signupForm });
      await this.$store.dispatch("signup", this.signupForm);

      this.showMonedero = false;
      this.resetForm();
      this.toggleForm();
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
